import { Collections, createMessageToBroadcast, Incident } from "api";
import { ExtendedFirestoreInstance } from "react-redux-firebase";

export const addBroadcastMessageIfNotExists = (
    firestore: ExtendedFirestoreInstance,
    roundId: string,
    incident: Incident,
    driversByNumber,
    infraction?
) => {
    return firestore
        .collection(Collections.ROUNDS)
        .doc(roundId)
        .collection(Collections.BROADCAST_MESSAGES)
        .where("statusIncident", "==", incident.status)
        .where("incidentId", "==", incident.id)
        .get()
        .then((snapshot) => {
            let exists = false;

            snapshot.forEach((doc) => {
                if (doc.exists) {
                    exists = true;
                }
            });

            if (!exists) {
                return firestore
                    .collection(Collections.ROUNDS)
                    .doc(roundId)
                    .collection(Collections.BROADCAST_MESSAGES)
                    .add(
                        createMessageToBroadcast(
                            incident,
                            roundId,
                            driversByNumber,
                            infraction
                        )
                    );
            }
        });
};
